import React, {useEffect, useState} from "react";
import {CLEARANCE_AGENTS_URL, DELETE_USER, SAVE_USER, USERS_URL,} from "../../../API/APIRoutes";
import GenericItemsListing from "../ListingItems/ListingItems";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import {Grid, TextField, Typography} from "@mui/material";
import DropDown from "@Components/DropDown/DropDown";
import Joi from "joi";
import {
    DropDownValidation,
    EmailValidation,
    NameValidation,
    OptionalDropDownValidation
} from "@Utils/Validations/UserValidations/UserValidationFieldsSchema";
import useGetAll from "@Hooks/useGetAll";
import {submitFormWithValidation, validateField} from "@Utils/Validations/HelperFunctions/FormValidationFunctions";


function UsersListing() {
    const attributes = [
        {key: "username", label: "User Name", flex: 1.5},
        {key: "email", label: "Email", flex: 2},
        {key: "role", label: "Role", flex: 1.5},
        {key: "agencyName", label: "Agency Name", flex: 1},
    ];

    const validationSchema = Joi.object({
        username: NameValidation("User Name"),
        email: EmailValidation,
        roles: DropDownValidation("Role"),
        agencyId: OptionalDropDownValidation("Agency"),
    });
    const [agencyNameOptions, setAgencyNameOptions] = useState([
        {id: "Select Agency", name: "Select Agency Name"},
    ]);
    const initialState = {
        username: "",
        email: "",
        roles: "Select Role",
        agencyId: agencyNameOptions[0].id,
    }
    const [newUserData, setnewUserData] = useState(
        initialState);

    const roleOptions = [
        {id: "Select Role", name: "Select Role"},
        {id: "CLEARANCE_MANAGER", name: "Clearance Manager"},
        {id: "CLEARANCE_AGENT", name: "Clearance Agent"},
        {id: "CLEARANCE_COORDINATOR", name: "Clearance Coordinator"},
        {id: "SYASAT", name: "Syasat Coordinator"},
        {id: "FORM_4", name: "Form 4 Coordinator"},
        {id: "FINANCIAL", name: "Financial Coordinator"},
        {id: "PLANNING_MANAGER", name: "Planning Manager"},
        {id: "PLANNER", name: "Planner"},
        {id: "TRANSPORTATION_COORDINATOR", name: "Transportation Coordinator"},
        {id: "QUALITY_MEMBER", name: "Quality Member"},
        {id: "WAREHOUSE_MEMBER", name: "Warehouse Member"},
        {id: "TREASURY_COORDINATOR", name: "Treasury Coordinator"},
        {id: "EXTERNAL_TREASURY_COORDINATOR", name: "External Treasury Coordinator"},
    ];

    const {getAll} = useGetAll();
    useEffect(() => {
        getAll(CLEARANCE_AGENTS_URL, `Failed to fetch Agencies`)
            .then((fetchedData) => {
                setAgencyNameOptions([
                    agencyNameOptions[0],
                    ...fetchedData.map((item) => ({
                        id: item.agentId,
                        name: item.agentName,
                    })),
                ]);
            })
            .catch((error) => console.error(error));
    }, []);


    const [errors, setErrors] = useState({});

    // Handle form submission
    const handleOnSubmit = async () => {
        // Ensure roles is always an array
        const updatedUserData = {
            ...newUserData,
            roles: [newUserData.roles], // Convert roles to an array
        };
        const condition = newUserData.roles !== "CLEARANCE_AGENT";
        return  submitFormWithValidation(updatedUserData, condition, "agencyId", setErrors, validationSchema);
    };
   const clearData = () => {
        setnewUserData(initialState);
        setErrors({});
   }

    const handleOnBlur = (field, value) => {
        validateField(field, value, setnewUserData, newUserData, validationSchema, setErrors);

    };
    const form = (
        <>
            {
                <form onSubmit={handleOnSubmit} className="formWrapper">
                    <Grid
                        className="inputContainer"
                        container
                        spacing={2}
                        justifyContent="flex-end"
                    >
                        <Grid item xs={12}>
                            <Typography variant="body1" sx={{mb: 1}}>
                                Username
                            </Typography>
                            <TextField
                                onBlur={(e) => handleOnBlur("username", e.target.value)}
                                value={newUserData.username || ""}
                                onChange={(e) => {
                                    setnewUserData({
                                        ...newUserData,
                                        username: e.target.value,
                                    });
                                    setErrors({...errors, username: ""}); // Clear error message on input change
                                }}
                                variant="outlined"
                                placeholder=" Username"
                                fullWidth
                                helperText={errors.username} // Show validation error message
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" sx={{mb: 1}}>
                                Email
                            </Typography>
                            <TextField
                                onBlur={(e) => {
                                    handleOnBlur("email", e.target.value);
                                }}
                                value={newUserData.email || ""}
                                onChange={(e) => {
                                    setnewUserData({...newUserData, email: e.target.value});
                                    setErrors({...errors, email: ""}); // Clear error message on input change
                                    // emailAlreadyExists.current = false; // Reset email exists flag
                                }}
                                variant="outlined"
                                placeholder="Email"
                                fullWidth
                                helperText={errors.email} // Show validation error message
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1" sx={{mb: 1}}>
                                Role
                            </Typography>
                            <DropDown
                                state={newUserData.roles}
                                setState={(value) => {
                                    setnewUserData({...newUserData, roles: value});
                                    setErrors({...errors, roles: "", agencyId: ""}); // Clear error message on selection
                                }}
                                name="role"
                                label=""
                                items={roleOptions}
                                placeholder="Select Role"
                                helperText={errors.roles}
                            />

                        </Grid>
                        {newUserData.roles === "CLEARANCE_AGENT" && (
                            <Grid item xs={12}>
                                <Typography variant="body2=3" sx={{mb: 1}}>
                                    Agency Name
                                </Typography>
                                <DropDown
                                    state={newUserData.agencyId}
                                    setState={(value) => {
                                        setnewUserData({...newUserData, agencyId: value});
                                        setErrors({...errors, agencyId: ""});
                                    }}
                                    name="agencyId"
                                    label=""
                                    items={agencyNameOptions}
                                    placeholder="Select Agency Name"
                                    helperText={errors.agencyId}
                                />
                            </Grid>
                        )}
                    </Grid>
                </form>
            }
        </>
    );

    return (
        <GenericItemsListing
            items_URL={USERS_URL}
            SAVE_Item={SAVE_USER}
            DELETE_Item={DELETE_USER}
            title="Users"
            name="User"
            icon={<PersonRoundedIcon fontSize="large" color="white"/>}
            attributes={attributes}
            customFormForAddtion={{formContent: form, formButton: handleOnSubmit}}
            uniqueId={"userId"}
            clearData={clearData}
        />
    );
}

export default UsersListing;
